import { PropsWithComponentData, useComponentData, useSplitter, useStore } from '@yimoka/react';
import { strToArr } from '@yimoka/shared';
import { Transfer as AntTransfer, TransferProps as AntTransferProps } from 'antd';
import { TransferDirection } from 'antd/es/transfer';
import React, { useMemo } from 'react';

import { strToIcon } from '../tools/icon';

/** Transfer 在封装数据源的同时保持 valueType 声明的双向值类型。 */
export const Transfer = (props: TransferProps) => {
  const {
    store, data, dataKey, dataSource, targetKeys,
    splitter, value, valueType, onChange,
    selectionsIcon,
    ...rest
  } = props;
  const curStore = useStore(store);
  const curData = useComponentData([dataSource, data], dataKey, curStore);
  const curSplitter = useSplitter(splitter);

  const curValue = useMemo(() => {
    if (targetKeys) {
      return targetKeys;
    }
    if (typeof value === 'string') {
      return strToArr(value, curSplitter);
    }
    return value;
  }, [targetKeys, value, curSplitter]);

  /** 将 Antd 的最新目标键按声明值类型回传给表单。 */
  const handleChange: AntTransferProps['onChange'] = (targetKeys, direction, moveKeys) => {
    if (valueType === 'string') {
      // 输出必须转换最新 targetKeys，不能因输入兼容形态不同而回写旧值或数组。
      onChange?.(targetKeys.join(curSplitter), direction, moveKeys);
    } else {
      onChange?.(targetKeys, direction, moveKeys);
    }
  };

  return (
    <AntTransfer
      {...rest}
      dataSource={curData}
      selectionsIcon={strToIcon(selectionsIcon)}
      targetKeys={curValue}
      onChange={handleChange}
    />
  );
};

Transfer.Search = AntTransfer.Search;

export type TransferProps = PropsWithComponentData<Omit<AntTransferProps, 'onChange'>> & {
  splitter?: string
  valueType?: 'string' | 'array'
  onChange?: (targetKeys: string | React.Key[], direction: TransferDirection, moveKeys: React.Key[]) => void
  value?: string | React.Key[]
}
